import { marked } from 'marked';
import { HEADERS } from './constants';

export function renderEmbedlyCards(elements: ArrayLike<Element>): void {
    const embedly = (window as any).embedly as ((cmd: string, ...args: unknown[]) => void) | undefined;
    if (embedly === undefined) return;
    if ((window as any).__embedlyHeaderHookInstalled !== true) {
        (window as any).__embedlyHeaderHookInstalled = true;
        // No card option hides the provider header row ("KUULA" etc.); the card
        // iframe is same-origin, so hide it with injected CSS once rendered.
        embedly('on', 'card.rendered', (iframe: HTMLIFrameElement) => {
            try {
                const doc = iframe.contentDocument;
                if (!doc?.head) return;
                const style = doc.createElement('style');
                style.textContent = '.card .hdr { display: none !important; }';
                doc.head.appendChild(style);
            } catch {
                // Cross-origin card — leave it as-is.
            }
        });
    }
    const key = HEADERS['X-Embedly-Key'] as string | null;
    for (let i = 0; i < elements.length; i++) {
        const el = elements[i];
        // Card options are only reliably honored as per-element attributes —
        // embedly('defaults') silently ignores controls. chrome: 0 removes the
        // card border; controls: 0 removes the hover share icons.
        if (typeof key === 'string' && key.length > 0) el.setAttribute('data-card-key', key);
        el.setAttribute('data-card-chrome', '0');
        el.setAttribute('data-card-controls', '0');
        embedly('card', el);
    }
}

// translated span can delay return so make it false if that is not needed
export function parseDescriptionText(description: string, openInNewTab: boolean = false, proxiEmbed: boolean = false, translated: boolean = true): string {
    let parsedDescription = marked.parse(description ?? '');
    parsedDescription = parsedDescription.replace(/href="(?!http:\/\/|https:\/\/|mailto:|tel:)/g, 'href="https://');
    parsedDescription = parsedDescription.replaceAll('<a', `<a target="${openInNewTab ? '_self' : '_blank'}"`);

    const parser = new DOMParser();
    const doc = parser.parseFromString(parsedDescription, 'text/html');

    function wrapTextNodes(node: Node) {
        if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim()) {
            const span = translated ? doc.createElement('translated-span') : doc.createElement('span');
            span.textContent = node.textContent;
            node.parentNode?.replaceChild(span, node);
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            Array.from(node.childNodes).forEach(wrapTextNodes);
        }
    }

    doc.querySelectorAll('p, a').forEach(wrapTextNodes);

    const links = doc.querySelectorAll('a');
    links.forEach(link => {
        const href = link.getAttribute('href');
        if (href?.includes('proxi_embed=true') === true || proxiEmbed) {
            link.classList.add('embedly-cardx');
        }
    });

    parsedDescription = doc.body.innerHTML;
    return parsedDescription;
}